// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {get, isEmpty, isEqual} from 'lodash';
import Favicon from './react/Favicon';

// toast related
import {
  ToastContainer,
  ToastMessage,
} from 'react-toastr';
const ToastMessageAnim = ToastMessage.animation;

// UI Components
import SnackBar from './common/components/SnackBar';
import Spinner from './common/components/Spinner';
import * as ui from './redux/actionCreators/sync/ui';

// material UI related
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

// used to bind functions to API call responses
import { bindToErrorAction, unbindFromErrorAction } from 'simple-iso-fetch';

// action creators for redux
// import * as asyncActionCreators from './redux/actionCreators/async';
import * as syncActionCreators from './redux/actionCreators/sync';

// toast errors
function errorToastFunc(res) {
  const errorList = get(res, 'body.errors', [{errorMessage: res.body}]);

  if (res.status >= 500) {
    return errorList.forEach(error => {
        this.refs.container.error(
          `${res.status} : ${error.errorMessage || 'Internal Server Error'}`,
          `${res.method} ${res.url}`,
          {closeButton: true}
        );
      })
    ;

  }
}

@connect(store => ({
  ui        : store.ui,
  userAgent : store.browserData.userAgent,
  staticData: store.staticData
}))
export default class App extends Component {
  static propTypes = {
    dispatch  : PropTypes.func,
    userAgent : PropTypes.string,
    ui        : PropTypes.object,
    children  : PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
  }

  componentWillMount() {
    // give the browser's scrollBarWidth to the rest of the app
    this.props.dispatch(syncActionCreators.getScrollBarWidth());
  }

  componentDidMount() {
    // transform response
    this.props.dispatch(bindToErrorAction(errorToastFunc.bind(this)));
    document.title = get(this.props.staticData, 'account.name', 'WAHVE');
  }

  componentWillReceiveProps(nextProps) {
    const currentToast = get(this, 'props.ui.toast', {});
    const nextToast = get(nextProps, 'ui.toast', {});

    if (!isEqual(currentToast, nextToast)) {
      this.showToastMessages(nextToast);
    }
  }

  componentWillUnmount() {
    // this is needed to avoid binding twice on hot reloading (good in principal regardless)
    this.props.dispatch(unbindFromErrorAction(errorToastFunc));
  }

  showToastMessages(toast) {
    if (isEmpty(toast)) {
      return;
    }

    this.refs.container.warning(toast.message, toast.title, {closeButton: true});
  }

  render() {
    const muiTheme = getMuiTheme({
      userAgent: this.props.userAgent || window && window.navigator.userAgent,
      fontFamily: 'Lato, Arial, sans-serif',
      palette: {
        primary1Color: '#2eb0e3', // theme color
        textColor: 'rgb(33, 35, 38)'     // main text color
      },
      textField: {
        underlineShow: false,
        focusColor: 'rgb(0, 188, 212)',
        textColor: 'rgb(33, 35, 38)',
        hintColor: 'rgb(33, 35, 38)',
        errorStyle: {
          color: 'rgb(33, 35, 38)'
        },
        floatingLabelColor: 'rgb(33, 35, 38)',
        disabledTextColor: 'rgb(33, 35, 38)'
      }
    });

    return (
      <div>
        <Favicon />
        <ToastContainer
          toastMessageFactory={props =>
            <ToastMessageAnim {...props}
              className='slide'
              transition='slide'
              timeOut={6000}/>}
          ref='container'
          className='toast-top-right'
        />
        <MuiThemeProvider muiTheme={muiTheme}>
          {this.props.children}
        </MuiThemeProvider>
        <SnackBar
            show={this.props.ui.showSnackBar || false}
            snackBarText={this.props.ui.snackBarText || 'Changes are saved'}
            autoHideDuration={1000}
            hideAction={this.props.ui.hideSnackBarAction || null}
        />
        {this.props.ui.showSpinner
          &&
          <Spinner/>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/App.js